export default {
    debug: false,
    items: {
        renderType: 'physics'
    },
    gui: {
        player: true,
        hint: true,
        inventory: true,
        discussion: true,
        death: true
    }
}

// food/drink consumed on take?